module.exports = __webpack_public_path__ + "img/product_106.b9815c8.webp";